import type { ReactNode } from 'react';
import { ArrowUpRight, Download } from 'lucide-react';
import { Typography } from './Typography';
import styles from './Button.module.css';
type Props = {
  children: ReactNode;
  href?: string;
  variant?: 'primary' | 'secondary' | 'light' | 'ghost';
  icon?: 'arrow' | 'download';
  download?: boolean;
  onClick?: () => void;
  type?: 'button' | 'submit';
  fullWidth?: boolean;
};
export function Button({
  children,
  href,
  variant = 'primary',
  icon,
  download,
  onClick,
  type = 'button',
  fullWidth = false,
}: Props) {
  const content = (
    <>
      <Typography as="span" variant="button" tone="inherit">
        {children}
      </Typography>
      {icon === 'arrow' && <ArrowUpRight size={18} aria-hidden />}
      {icon === 'download' && <Download size={18} aria-hidden />}
    </>
  );
  const cls = `${styles.button} ${styles[variant]} ${fullWidth ? styles.fullWidth : ''}`;
  return href ? (
    <a className={cls} href={href} download={download || undefined}>
      {content}
    </a>
  ) : (
    <button className={cls} onClick={onClick} type={type}>
      {content}
    </button>
  );
}
